import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import authModule from "./authModule";
import generalInformationModule from "@/store/generalInformationModule";
import documentsModule from "@/store/Documents/documentModule";
import projectsModule from "./Projects/index";
import publicModule from "./public/public";
import clientModule from "@/store/clientModule";
import websiteModule from "@/store/websiteModule";
import onboardingModule from "@/store/onboarding";
import DocGenModule from "@/store/DocGen";
import billingModule from "@/store/billing";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    key: "termshub",
    modules: [
        "auth",
        "generalInformation",
        "documents",
        "projects",
        "projectsModule",
        "public",
        "client",
    ],
    restoreState: (key, storage) => {
        const value = storage.getItem(key);
        return typeof value === "string"
            ? JSON.parse(value || "{}")
            : value || {};
    },
    // saveState: (key, state, storage) => {
    //     try {
    //         storage.setItem(key, JSON.stringify(state));
    //     } catch (e) {
    //         storage.clear()
    //         state.setItem(key, JSON.stringify({auth: state.auth, client: state.client}));
    //     }
    // }
});

let store = new Vuex.Store({
    plugins: [vuexLocal.plugin],
    strict: process.env.NODE_ENV !== "production",
    state: {
        termsAgree: false,
        translations: {},
    },
    mutations: {
        changeTermsAgree(state, data = false) {
            state.termsAgree = data;
        },
        addTrans(state, data) {
            this.translations = {
                ...this.translations,
                [data]: "",
            };
        },
    },
    actions: {},
    modules: {
        auth: authModule,
        generalInformation: generalInformationModule,
        public: publicModule,
        documents: documentsModule,
        projects: projectsModule,
        client: clientModule,
        website: websiteModule,
        onboarding: onboardingModule,
        billing: billingModule,
        docGen: DocGenModule,
    },
});

export default store;
